enum FacilityStatus {
    OK = 0,
    WARNING = 1,
    ERROR = 2,
    ALL = 3,
    SUSPENDED = 4
}

enum FacilityStatusStrings {
    ALL = 'ALL',
    OK = '0',
    WARNING = '1',
    ERROR = '2',
    SUSPENDED = '3'
}

export { FacilityStatus, FacilityStatusStrings }
